const ApiManagementFormConfig = {
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": "checkbox",
                        "name": "api_enabled",
                        "label": "Activar el API externa para esta empresa",
                    }
                ]
            ]
        }
    ],
};

export default ApiManagementFormConfig;
